import {
  Row
} from "antd";
import Temp1 from "./templates/1_template.svg";
import Temp2 from "./templates/2_template.svg";
import Temp3 from "./templates/3_template.svg";
import Temp4 from "./templates/4_template.svg";
import Temp5 from "./templates/5_template.svg";
import Temp6 from "./templates/6_template.svg";

const getTemp = (num) => {
  if (num === 1) return Temp1;
  if (num === 2) return Temp2;
  if (num === 3) return Temp3;
  if (num === 4) return Temp4;
  if (num === 5) return Temp5;
  if (num === 6) return Temp6;

  return null;
};

export default ({ num }) => {
  return (
    <Row justify="center" style={{ marginTop:"1rem",  marginBottom:"1rem"}}>
      <img width="100%" height="100%" src={getTemp(num)} alt="email-sent" />
    </Row>
  );
};
